export default __webpack_public_path__ + "df656f192dcc60cac1fc6fb4331594bd.svg";